import { useState, useEffect } from 'react';
import { ISuggestion } from '../../../../../../../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import { IFieldError } from '../../../../../../../../../../../../Types/FormTypes';
// eslint-disable-next-line aveny/mui-import-rule
import { PopperPlacementType } from '@mui/material/Popper';
import { EDAutoCompleteEdit } from '../../../../../../../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import { useIsTouchDevice } from '../../../../../../../../../../../../Components/BreakpointContext/BreakpointContextUtils';

interface IProps {
  value: string | null;
  onChange: (newValue: string) => void;
  onBlur: (value: string) => void;
  touched: boolean;
  fieldErrors?: IFieldError[];
  label: string;
  suggestions: ISuggestion[];
  suggestionsContainerPlacement?: PopperPlacementType;
  hidden?: boolean;
  autoFocus?: boolean;
  fullWidth?: boolean;
}

const getSearchValue = (
  value: string | null,
  suggestions: ISuggestion[]
): ISuggestion | undefined => {
  const suggestion = suggestions.find(suggestion => suggestion.value === value);

  return suggestion;
};

const hasErrors = (
  fieldErrors: IFieldError[] | undefined
): fieldErrors is IFieldError[] =>
  fieldErrors != null && fieldErrors.length > 0;

/**
 * Autocomplete för att välja kolumn värde i kolumnediteringsdialogen
 */
const EkonomiskAnalysEditColumnAutosuggest: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const isTouchDevice = useIsTouchDevice();
  const [value, setValue] = useState(
    getSearchValue(props.value, props.suggestions)
  );
  useEffect(() => {
    setValue(getSearchValue(props.value, props.suggestions));
  }, [props.value, props.suggestions]);

  const onSuggestionSelected =
    (onChange: (value: string) => void) => (suggestion: ISuggestion | null) => {
      setValue(suggestion ?? undefined);
      onChange(suggestion?.value ?? '');
    };

  const onFocus = () => {
    if (!isTouchDevice) {
      setValue(undefined);
    }
  };

  const onBlur = () => {
    if (value) {
      props.onBlur(value?.value);
    }
  };

  return (
    <EDAutoCompleteEdit<ISuggestion>
      value={value}
      options={props.suggestions}
      label={props.label}
      onChange={onSuggestionSelected(props.onChange)}
      getOptionLabel={suggestion => suggestion.name}
      fullWidth={props.fullWidth}
      onFocus={onFocus}
      onBlur={onBlur}
      autoFocus={props.autoFocus}
      errorMessage={
        hasErrors(props.fieldErrors) && props.touched
          ? props.fieldErrors[0].message
          : undefined
      }
      disableOpenOnFocus
    />
  );
};

export default EkonomiskAnalysEditColumnAutosuggest;
